// @ts-nocheck
import { getShareholderVoteStatus } from '../shared/voteRoomVoteStatus';
import { VoteRoomSlideOver } from './VoteRoomSlideOver';
import { VoteRoomShareholderSummary } from './VoteRoomShareholderSummary';
import { ShareholderPortal } from '../portal/ShareholderPortal';

/** Slide-over that previews the shareholder consent experience as the admin in "view-as" mode. */
export const PreviewVoteRoomSlideOver = ({
  shareholder,
  shareholders,
  eligibleShares,
  onClose,
  voteRoomClosed,
  companyName,
}) => {
  const active = shareholder ? shareholders.find((s) => s.id === shareholder.id) || shareholder : null;
  const statusVariant = active ? getShareholderVoteStatus(active, { voteRoomClosed }) : null;
  return (
    <VoteRoomSlideOver
      open={shareholder != null}
      onClose={onClose}
      title="Preview Vote Room"
      titleId="vote-room-preview-slide-title"
      subtitle={active?.name}
      statusVariant={statusVariant}
    >
      {active ? (
        <div className="space-y-5">
          <VoteRoomShareholderSummary
            shareholder={active}
            eligibleShares={eligibleShares}
            voteRoomClosed={voteRoomClosed}
          />
          <div>
            <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-gray-500">
              Shareholder Experience
            </h4>
            <ShareholderPortal
              shareholder={active}
              voteRoomClosed={voteRoomClosed}
              companyName={companyName}
              compactHeader
              readOnlyPreview
            />
          </div>
        </div>
      ) : null}
    </VoteRoomSlideOver>
  );
};
